import { IHolding } from "../holding"
import { ITown } from "../town"
import { INewCroppingYear, IOmniaHttpService } from "../types"
import { isArrayEmpty } from "../utils/array"
import { SessionInfo } from "./types"

/** @internal */
export class SessionApi {

    private towns: ITown[]

    constructor(private ohttp: IOmniaHttpService) {
    }

    startSession(initialHoldingId: number, inviteId: string): ng.IPromise<SessionInfo> {

        const request = {
            initialHoldingId,
            acceptedInviteId: inviteId
        }

        const url = "/api/session/v1/start"

        return this.ohttp.post(url, request).then(r => r.data ? r.data : r);

    }

    queryHoldings(query: string, limit?: number): PromiseLike<IHolding[]> {
        const url = `/api/session/v1/holdings/query?query=${encodeURIComponent(query)}&limit=${limit ?? 20}`
        return this.ohttp.get(url, false).then(r => r.data as IHolding[])

    }

    getCurrentHolding(): ng.IPromise<IHolding> {
        const url = "/api/service/holding/current"
        return this.ohttp.get(url).then(r => {
            const holdings = this.setupHoldings(r.data)
            return isArrayEmpty(holdings) ? undefined : holdings[0]
        })
    }

    getUserHoldings(): ng.IPromise<IHolding[]> {
        const url = "/api/service/holdings?v=3"
        return this.ohttp.get(url).then(r => this.setupHoldings(r.data))
    }

    setupHoldings(data: { Holdings: IHolding[], Towns: ITown[] }) {

        if (data) {

            const holdings = data.Holdings
            const towns = data.Towns ?? this.towns

            if (towns) {

                holdings.forEach(h => {
                    h.Town = towns.find(t => t.TownId == h.TownId)
                })

                this.towns = towns

            }

            return holdings

        }

    }

    openCroppingYear(model: INewCroppingYear): ng.IPromise<boolean> {

        const url = "/api/holdings/v1/year"

        return this.ohttp.put(url, model).then(r => r.data ? !!r.data : false)

    }

    setUserSetting(userId: number, holdingId: number, key: string, value: any): ng.IPromise<any> {

        const url = "/api/service/settings/save"

        return this.ohttp.post(url, { UserId: userId, HoldingId: holdingId, Key: key, Value: value }, { changeApiVersion: false, blockUi: false });

    }

}
